// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quotationDetail[data-v-31e0f74d]  .el-form-item__label {\n  font-size: 12px;\n  font-weight: normal;\n}\n.quotationDetail[data-v-31e0f74d]  .length-weight-height /deep/ .el-input-number {\n  width: 59px !important;\n}\n.el-form .length-weight-height[data-v-31e0f74d] .el-input-number {\n  width: 59px;\n}\n", ""]);
// Exports
module.exports = exports;
